import { Component, type ReactNode } from "react";

interface Props { children: ReactNode }
interface State { error: Error | null }

/**
 * Catches any runtime render error so the user never sees a silent blank
 * page. Shows the error message (useful for support screenshots) and a
 * reload button.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="page" style={{ justifyContent: "center", textAlign: "center" }}>
          <h2 className="h2">Something went wrong</h2>
          <p style={{ color: "var(--color-text-secondary)", margin: "12px 0 20px", fontSize: 14 }}>
            {this.state.error.message}
          </p>
          <button
            className="btn-primary"
            onClick={() => { window.location.href = "/"; }}
          >
            Reload app
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
